/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck

import styled from 'styled-components';
import Image from 'react-bootstrap/Image';
import ListGroup from 'react-bootstrap/ListGroup';

export const IconImage: any = styled(Image)`
  width: 1rem;
  height: 1rem;
`;

export const IconContainer = styled(ListGroup.Item)`
  display: flex;
  align-items: center;
  background-color: transparent;
`;

export const SubTitle = styled.h5`
  word-break: break-word;
  font-weight: bold;
  font-size: 0.8rem;
`;

export const Title = styled.h4`
  font-size: 0.8rem;
`;
